var map = {
  "./admin.js": "32067",
  "./agent.js": "82769",
  "./auth.js": "53188",
  "./businessSchool.js": "87332",
  "./common.js": "3211",
  "./compulsoryCourse.js": "4762",
  "./content.js": "25445",
  "./contract.js": "1488",
  "./course.js": "32615",
  "./courseClassification.js": "40791",
  "./demo.js": "33049",
  "./diy.js": "27870",
  "./examine.js": "21335",
  "./finance.js": "40222",
  "./goods.js": "32330",
  "./information.js": "74734",
  "./levelConfig.js": "31652",
  "./marketing.js": "10788",
  "./material.js": "21047",
  "./medal.js": "19747",
  "./operations.js": "57228",
  "./order.js": "71772",
  "./phraseLibrary.js": "31640",
  "./points.js": "43761",
  "./problem.js": "73571",
  "./product.js": "22451",
  "./proxy.js": "76296",
  "./report.js": "3856",
  "./retail.js": "71573",
  "./sms.js": "32405",
  "./statistic.js": "17446",
  "./supplier.js": "7586",
  "./system.js": "7395",
  "./task.js": "94691",
  "./test.js": "6694",
  "./user.js": "1997",
  "./userLesson.js": "18489",
  "./work.js": "46871"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 96968;
